import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingOverlayService } from '@core/services/loading-overlay.service';
import { SpinkitComponent } from '@app/components/loading/spin-kit.component';

@Component({
    selector: 'app-loading-overlay',
    standalone: true,
    imports: [CommonModule, SpinkitComponent],
    template: `
        <div *ngIf="isVisible$ | async" class="loading-overlay">
            <app-spinkit type="chase" [size]="60" color="#1ab394" />
        </div>
    `,
})
export class LoadingOverlayComponent {
    private service = inject(LoadingOverlayService);
    isVisible$ = this.service.isVisible$;
}
